<template>

  <div class="vflex">

    <div
      class="vflex-row-0 vflex-header p-3"
      v-if="$slots.header">
      <slot
        name="header">
        </slot>
    </div>

    <div class="vflex-row-1">

      <creating
        v-if="creating"
        height="100%" />

      <!--content-->
      <div
        v-if="!creating"
        :class="{'box-loading': loading}">
        
        <slot
          v-if="total>=1"
          name="content">
          </slot>

        <no-results
          v-if="total===0"
          class="p-3">
          <slot name="noresults"></slot>
          </no-results>

      </div>
      <!--end content-->

    </div>

    <div
      v-if="!creating && total"
      class="vflex-row-0 vflex-footer p-3">

      <div class="d-flex justify-content-between">
        <div
          class="p-1"
          v-html="$tc('n_records', total, { count: total })">
        </div>
        <pagination 
          v-if="pages >= 2"
          :total-pages="pages" 
          :current-page="page"
          @changePage="changePage">
          </pagination>
      </div>

    </div>

  </div>

</template>

<script>
import Pagination from '@/components/Parts/Pagination'

export default {
  name: 'Modalo',
  components: {
    Pagination
  },
  props: {
    'total': {
      type: Number,
      default: 0
    },
    'pages': {
      type: Number,
      default: 0
    },
    'page': {
      type: Number,
      default: 0
    },
    'creating': {
      type: Boolean,
      default: false
    },
    'loading': {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  created () {
  },
  computed: {
  },
  methods: {
    changePage (val) {
      this.$emit('changePage', val)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Paginaty/Paginaty.vue